import { useNarrow } from '../../../lib/use-narrow';
import { TaskDetailDesktop } from './desktop/TaskDetailDesktop';
import { TaskDetailMobile } from './mobile/TaskDetailMobile';

// The task-details drill-in, opened from a task card via openModal. The two viewports are genuinely
// different surfaces — wide is the DS centered <Modal> (Figma 12801-105529); narrow is a full-screen
// sheet (Figma 12175-102348) — so they are two components rather than one with breakpoint branches.
// Everything they DO is shared: useTaskDetailModal owns the read, the derivation, the BI and the actions.
export function TaskDetailModal({ taskId }: { taskId: string }) {
  const narrow = useNarrow();
  return narrow ? <TaskDetailMobile taskId={taskId} /> : <TaskDetailDesktop taskId={taskId} />;
}
